import { render } from "./Field.vue?vue&type=template&id=1b986a48&scoped=true&lang=pug"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"

import "./Field.vue?vue&type=style&index=0&id=1b986a48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b986a48"]])

export default __exports__